import AdminNewLogo from '../../svgs/AdminNewLogo';

import styles from './AdminAuthWrapper.module.scss';

const AdminAuthWrapper = ({ children, headText }: any) => (
  <div className={styles?.authLayout}>
    <div className={`${styles?.authLayout__row} row`}>
      <div className={`${styles?.authLayout__left} col-md-6 col-12`}>
        <div className={styles?.authLayout__content}>
          <div className={styles?.authLayout__logo}>
            <AdminNewLogo width="132" height="68" />
          </div>
          <div className={styles?.authLayout__title}>{headText}</div>
          {children}
        </div>
      </div>
      <div className={`${styles?.authLayout__right} col-md-6 col-12`}> </div>
    </div>
  </div>
);
export default AdminAuthWrapper;
